'use client';
import { useBridgeContext } from '@/BridgeProvider';
import { Currency, NetworkOption } from '@/constants';
import Image from 'next/image';
import { useEffect, useRef, useState } from 'react';
import { useClickAway } from 'react-use';
import { twMerge } from 'tailwind-merge';
interface DropdownProps {
  inputSection?: boolean;
  options: Currency[] | NetworkOption[];
  className?: string;
}

export const Dropdown = ({ inputSection, options, className }: DropdownProps) => {
  const { state, dispatch } = useBridgeContext();

  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState<Currency | NetworkOption>(options[0]);

  const handleOptionClick = (option: Currency | NetworkOption) => {
    setSelectedOption(option);
    setIsOpen(false);
  };

  const ref = useRef(null);
  useClickAway(ref, () => setIsOpen(false));

  useEffect(() => {
    // this will be refactored soon
    if (Object.prototype.hasOwnProperty.call(selectedOption, 'l1')) {
      dispatch({ type: 'SET_SELECTED_CURRENCY', payload: selectedOption.label });
    }
  }, [selectedOption, dispatch]);

  const available = state.view === 'deposit' ? state.L1_balances : state.L2_balances;

  return (
    <div
      className={twMerge('inline-block z-20', className)}
      ref={ref}
      style={{
        position: inputSection ? 'unset' : 'relative',
        zIndex: inputSection ? 11 : '',
      }}
    >
      <div>
        <button
          onClick={() => setIsOpen(!isOpen)}
          type="button"
          className="inline-flex items-center w-full sm:w-auto px-3 sm:px-4 py-2 font-medium border border-neutral-600 rounded-md bg-neutral-black"
          id="options-menu"
          aria-haspopup="listbox"
          style={{
            borderBottomLeftRadius: isOpen || inputSection ? 0 : '',
            borderBottomRightRadius: isOpen ? 0 : '',
            borderBottom: isOpen ? 'none' : '',
            background: inputSection ? '#212529' : '',
            borderTopLeftRadius: inputSection ? 0 : '',
            minWidth: '120px',
          }}
        >
          <Image src={selectedOption.logo} alt="svg" width={18} height={18} />
          <span className="mx-2 font-normal">{selectedOption.label}</span>
          <Image src={'/down_arrow.svg'} alt="svg" width={24} height={24} className="ml-auto" />
        </button>
      </div>

      {isOpen && (
        <div
          className="absolute right-0 w-full rounded-md border border-neutral-600 bg-neutral-black"
          style={{
            borderTopLeftRadius: 0,
            borderTopRightRadius: 0,
            background: inputSection ? '#212529' : '',
          }}
        >
          <ul
            role="listbox"
            aria-labelledby="options-menu"
            aria-activedescendant="selected-option"
            className="py-1 w-full sm:w-auto"
          >
            {options.map((option, ix) => (
              <li
                key={`${option.label}-${ix}`}
                onClick={() => handleOptionClick(option)}
                className="text-neutral-950 cursor-pointer select-none relative px-4 py-2 flex items-center"
              >
                <div className="flex items-center space-x-2">
                  <Image src={option.logo} alt="svg" width={18} height={18} className="ml-auto" />
                  <span> {option.label} </span>
                </div>

                {inputSection && <div className="ml-auto text-xs">{available[option.label]} available</div>}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};
